module.exports = __webpack_public_path__ + "cc56582653ed5b4fdb75fd123fad08af.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/message_saved_2x.png
// module id = 134
// module chunks = 0 1 2 3 4